var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-checkbox',{attrs:{"checked":_vm.isChecked,"value":_vm.isChecked,"indeterminate":_vm.isCheckSome,"label":"全选","border":"","disabled":!_vm.hasNeedConfirm},on:{"change":_vm.clickCheckAll}})}
var staticRenderFns = []

export { render, staticRenderFns }